import {Component, HostListener, OnInit} from "@angular/core";
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { routingAway } from "../helpers/pendingChanges.guard";
import { Applicant } from '../models/applicant';
import { IncomeRent } from '../models/incomeRent';
import { NavigationParameters } from "../models/navigationParameters";
import { Parameters } from '../models/parameters';
import { PopupMessage } from "../models/popupMessage";
import { WaitlistTypes } from "../models/waitlistTypes";
import { ApplicantService } from '../services/applicant.service';
import { ApplicationPendingChangesService } from "../services/application-pending-changes.service";
import { ConfirmationPopupMessageService } from "../services/confirmation-popup-message.service";
import { MessageService } from '../services/message.service';
import { WaitlistService } from "../services/waitlist.service";


@Component ({
    selector: 'income-rent',
    templateUrl: './income-rent.component.html',
    styleUrls: ['./income-rent.component.scss']
})

export class IncomeRentComponent implements OnInit, routingAway{
    applicant: Applicant = new Applicant;
    incomeRent:IncomeRent = new IncomeRent;
    params:Parameters = new Parameters();
    readonly:boolean = false;
    formInvalid:boolean = false;
    navigationParams:NavigationParameters = new NavigationParameters();
    maxAmount:number = 199999;
    popupMessages: PopupMessage[] = [];
    isMobile:boolean = false;
    @HostListener('window:beforeunload')
    canDeactivate() {
        return this.routingAway();
    }

    routingAway():boolean {
        return this.appPendingChangesService.getPendingChanges();
    }
    
    
    constructor (
        private applicantService:ApplicantService, 
        private waitlistService:WaitlistService,
        private spinnerService: NgxSpinnerService,
        private msg:MessageService,
        private confirmationPopupMessageService: ConfirmationPopupMessageService,
        private router:Router,
        private appPendingChangesService:ApplicationPendingChangesService){
            this.isMobile = window.innerWidth < 768;        
    }

    ngOnInit(){
        this.spinnerService.show();
        this.applicant = JSON.parse(localStorage.getItem('applicant'));
        this.navigationParams = JSON.parse(localStorage.getItem('navigationParams'));
        this.incomeRent = this.applicant.incomeRent;
        this.params.hmy = this.applicant.generalInfo.hmy;
 
        if (this.navigationParams.formMode == null) this.navigationParams.formMode = '';
        if (this.navigationParams.affPCode == null) this.navigationParams.affPCode = '';

        //set readonly mode
        if (this.navigationParams.formMode.toUpperCase() == 'HCVVIEW' || this.navigationParams.userRole.toUpperCase() == 'STAFF')
            this.readonly = true;
        else
        {
            if (this.applicant.generalInfo.tenantStatus.toUpperCase() == 'CURRENT' || this.applicant.generalInfo.tenantStatus.toUpperCase() == 'NOTICE')
                if (this.navigationParams.affPCode.length > 0 || (this.navigationParams.waitlistTypesModel && this.navigationParams.waitlistTypesModel.yardiDB && this.navigationParams.waitlistTypesModel.yardiDB == 'AFF'))
                    this.readonly = false;
                else
                    this.readonly = true;
        }

        this.waitlistService.getPopupMessages().subscribe((p) => {
            this.popupMessages = p;
            }, (error) => {
                this.spinnerService.hide();
                this.msg.showError(error, "Loading Error");
        });


        if ((!this.incomeRent && this.applicant.generalInfo.pCode) || (this.incomeRent && this.incomeRent.hmy != this.applicant.generalInfo.hmy))
        {
            if (this.applicant.generalInfo.pCode.substring(0,1).toUpperCase() == 'P')
            {
                this.applicantService.getIncomeRentAff(this.params)
                .subscribe(data  => { 
                    if (data) this.incomeRent = data;
                }, (error) => {
                    this.spinnerService.hide();
                    this.msg.showError(error, "Loading Error");
                });
            }
            else
            {
                this.applicantService.getIncomeRentHCV(this.params)
                .subscribe(data  => { 
                    if (data) this.incomeRent = data;
                }, (error) => {
                    this.spinnerService.hide();
                    this.msg.showError(error, "Loading Error");
                });
            }
        }
        if (!this.incomeRent) this.incomeRent = new IncomeRent();
        this.spinnerService.hide();
    }
 

    showConfirmMessage(e:any, code:string){
        if(e.target.value == 1)
        {
            let popupMsg = this.popupMessages.filter(p => p.code == code)[0];
            if (popupMsg)
            {
                this.confirmationPopupMessageService.confirm(popupMsg, "lg")
                .then(result => {
                    if (result == true)
                    {
                        //get if did not agree uncheck the value
                        let agreeText = JSON.parse(localStorage.getItem('agree'));
                        if (!agreeText || agreeText?.toUpperCase() == 'NO')
                        {
                            e.target.value = 0;
                            if (e.target.name == 'renting')
                                this.incomeRent.renting = 0;
                        }
                    }
                })
            }
        }   
    }


    back(f:any)
    {
        // if (f.invalid && this.readonly == false)
        //     this.formInvalid = true;
        // else
        // {
            this.setFieldValues();
            this.applicant.incomeRent = this.incomeRent;
            localStorage.setItem('applicant', JSON.stringify(this.applicant));
            this.router.navigate(['/raceEthnicity']);
        // }
    }

    next(f:any){
        if (f.invalid && this.readonly == false)
            this.formInvalid = true;
        else
        {
            this.setFieldValues();
            this.applicant.incomeRent = this.incomeRent;        
            localStorage.setItem('applicant', JSON.stringify(this.applicant));
            this.router.navigate(['/familyMembers']);
        }
    }

    setFieldValues(){
        this.incomeRent.resSSI = + this.incomeRent.resSSI;
        this.incomeRent.renting = + this.incomeRent.renting;
        this.incomeRent.monthlyGross = this.incomeRent.monthlyGross == -0? 0 : + this.incomeRent.monthlyGross;
        this.incomeRent.monthlyRent = this.incomeRent.monthlyRent == -0 || this.incomeRent.renting == 0 ? 0 : + this.incomeRent.monthlyRent;
        this.incomeRent.monthlyUtility = this.incomeRent.monthlyUtility == -0 || this.incomeRent.renting == 0 ? 0 : + this.incomeRent.monthlyUtility;
    }
}